import { http } from "../config.api.js"

// goodProject

// 优良项目考评相关
export const materialPostRecord = (pageInfo, params) => {
    return http.get("/projectMaterialsPost/materialPostRecord/" + pageInfo, { urlParams: params }).then(res => res.data);
};

export const getSpotCheckNotice = (pageInfo, params) => {
    return http.get("/safetyGoodProjectEval/selectGoodProjectSpotCheckNotice/" + pageInfo, { urlParams: params }).then(res => res.data);
};

export const getMonthevalSpSearch = (pageInfo, params) => {
    return http.get("/safetyGoodProjectEval/safetyProjectmonthevalSpSearch/" + pageInfo, { urlParams: params }).then(res => res.data);
};

export const getGoodProjectHz = (pageInfo, params) => {
    return http.get("/safetyGoodProjectEval/selectGoodProjectHz/" + pageInfo, { urlParams: params }).then(res => res.data);
};

export const getGoodProjectReady = (pageInfo, params) => {
    return http.get("/safetyGoodProjectEval/selectGoodProjectReady/" + pageInfo, { urlParams: params }).then(res => res.data);
};
export const countBiddingGoodProjects = params => {
    return http.get("/safetyGoodProjectEval/countBiddingGoodProjects", { urlParams: params }).then(res => res.data);
};
export const getItem = params => {
    return http.get("/safetyGoodProjectEval/selectGoodProjectInfo", { urlParams: params }).then(res => res.data);
};


export const deleteEntity = params => {
    return http.delete("/safetyGoodProjectEval/delete", params).then(res => res.data);
};

export const updatePojo = params => {
    return http.post("/safetyGoodProjectEval/add", params).then(res => res.data);
}; 


export const cityGoodProjectHz = (pageInfo, params) => {
    return http.get("/safetyGoodProjectEval/cityGoodProjectHz/" + pageInfo, { urlParams: params }).then(res => res.data);
};

export const monthlyReview = (pageInfo, params) => {
    return http.get("/safetyGoodProjectEval/safetyProjectmonthevalSpSearch/" + pageInfo, { urlParams: params }).then(res => res.data);
};
export const shutdownDetails = (pageInfo, params) => {
    return http.get("/safetyGoodProjectEval/selectGoodProjectSpotCheckNotice/" + pageInfo, { urlParams: params }).then(res => res.data);
};

export const watchItem = params => {
    return http.get("/safetyGoodProjectEval/", { urlParams: params }).then(res => res.data);
};
//现场考核登记
export const  inspection = params => {
    return http.get("/safetyGoodProjectEval/goodProjectCheckEdit/", { urlParams: params }).then(res => res.data);
};

//设备登记
export const equipment = params => {
    return http.get("/safetyGoodProjectEval/goodProjectEquipEdit/", { urlParams: params }).then(res => res.data);
};

//设区申报
export const undeclared = params => {
    return http.get("/safetyGoodProjectEval/cityGoodProject/", { urlParams: params }).then(res => res.data);
};


//项目报建的质量管理过程查看
export const everyday = params => {
    return http.get("tproject/hyProjectProcessInfo/", { urlParams: params }).then(res => res.data);
};
//项目报建的质量管理过程查看/申报查看
export const declare = params => {
    return http.get("tproject/hyDeclareItemProcessQueryList", { urlParams: params }).then(res => res.data);
};


//建设单位对监理的评价
export const evaluate = params => {
    return http.get("/unitInfo/unitEncrypted", { urlParams: params }).then(res => res.data);
};
//监督部门两个工作事项清单查询
//export const stochastic = (pageInfo, params) => {
//	console.log(pageInfo,params)
//  return http.get("/tproject/projectListPublic/" + pageInfo, { urlParams: params }).then(res => res.data);
//};
//双随机管理 动态季度监管记分评价事项清单查询
export const dynamic = params => {
    return http.get("/tproject/projectListView", { urlParams: params }).then(res => res.data);
};
//双随机管理 事项清单附件查看
export const eventlist = params => {
    return http.get("/tproject/spotCheckDataInfoList", { urlParams: params }).then(res => res.data);
};

// // 责改停工
// export const getItem = params => {
//     return http.get("/safetyGoodProjectEval/selectGoodProjectInfo", { urlParams: params }).then(res => res.data);
// };

// export const materialPostRecord = (pageInfo, params) => { return http.get("/projectMaterialsPost/materialPostRecord/" + pageInfo, { urlParams: params }).then(res => res.data); };

// export const getProjectMaterialDetail = params => { return http.get("/projectMaterialsPost/projectMaterialDetail", { urlParams: params }).then(res => res.data); };


// export const revokeProjectMaterial = params => { return http.post("/projectMaterialsPost/revoke", params).then(res => res.data); };


// WEBPACK FOOTER //
// ./src/api/safetyCheck/api_GoodProject.js